import { useEffect } from 'react';

interface PreloaderProps {
    onLoadingComplete?: () => void;
    minLoadingTime?: number;
}

export default function Preloader({ onLoadingComplete, minLoadingTime = 1500 }: PreloaderProps) {
    useEffect(() => {
        const timeoutId = window.setTimeout(() => {
            onLoadingComplete?.();
        }, minLoadingTime);

        return () => window.clearTimeout(timeoutId);
    }, [minLoadingTime, onLoadingComplete]);

    return (
        <div className="flex h-screen w-screen items-center justify-center text-[#151515]">
            <span className="animate-pulse text-lg font-medium">Loading...</span>
        </div>
    );
}
